import { useGtag } from '#imports'

/**
 * Thin wrapper around the nuxt-gtag `useGtag` auto-import. Isolating the `#imports` access here lets
 * plugin/pipeline code that needs gtag be unit-tested (this module is mocked in specs) without the
 * Nuxt imports transform trying to resolve `useGtag`, which is not registered in the test build.
 */
export function getGtag(): { gtag: ((...args: unknown[]) => void) | undefined } {
  return useGtag()
}
